<template>
    <div class="cs-offerAddedToCart cs-formBoxContainer" v-if="isShown">
        <img src="https://comprasocial.me/wp-content/uploads/2019/09/checked@2x.png" alt="" class="cs-offerAddedToCart__image">
        <div class="cs-offerAddedToCart__message"> {{dictionary.addToCartSuccess}} </div>
        <div class="cs-formSubmitButton" v-on:click="$emit('closeComponent')">
          {{dictionary.continueToBuy}}
        </div>
        <div class="cs-formSubmitButton cs-formSubmitButton--purple" v-on:click="goToCheckout()">
          {{dictionary.goToCart}}
        </div>
      </div>
</template>

<script>
export default {
  name: 'OfferAddedToCart',
  props: {
    isShown: Boolean,
    dictionary: Object
  },
  emits: ['closeComponent'],
  methods: {
    goToCheckout: function(){
      document.getElementsByClassName('cs-header__cartWrapper')[0].click();
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/form.scss';
  .cs-offerAddedToCart{
    &__image{
      width: 50px;
      height: 50px;
    }

    &__message {
      font-size: 20px;
      font-weight: 700;   
      color: #7762ef;
    }
  }
</style>